import React from 'react';

const DisclaimerSection = ({ regionText }) => {
  return (
    <div className="flex flex-col gap-2 mt-5">
      <p className="text-secondary100/50 font-light text-base leading-6">
        Disclaimer
      </p>
      <p className="text-secondary100 font-light text-base leading-6 pb-5">
        Offer for iOS users only. {regionText.text ?? 'USD'} {/*Prices revert to
        $49.99 yearly after the first year.*/} Cancel anytime.
      </p>
    </div>
  );
};

export default DisclaimerSection;